<script lang="ts">
  import { t } from '../i18n';
  import { fps } from '../state/stores';
</script>

<div class="panel fps" role="status" aria-label={$t('fps.label')}>
  {Math.round($fps)} fps
</div>

<style>
  .fps {
    position: fixed;
    top: calc(var(--hud-top) + 8px);
    right: calc(env(safe-area-inset-right) + 8px);
    padding: 4px 8px;
    font-family: var(--font-mono);
    font-variant-numeric: tabular-nums;
    font-size: 0.8rem;
    pointer-events: none;
  }
</style>
